export function isError(error: unknown): error is Error {
    return error instanceof Error
}

export function isDocStatEntry(
    value: unknown
): value is { lastOpened: number; openCount: number } {
    if (typeof value !== "object" || value === null) return false
    const obj = value as Record<string, unknown>
    return (
        typeof obj.lastOpened === "number" && typeof obj.openCount === "number"
    )
}

export function isDocStats(
    value: unknown
): value is Record<string, { lastOpened: number; openCount: number }> {
    if (typeof value !== "object" || value === null || Array.isArray(value)) {
        return false
    }
    return Object.values(value).every(isDocStatEntry)
}

export function isApiDocument(value: unknown): value is {
    id: string
    documentType?: string
    name?: string
    referenceNumber?: string
} {
    if (typeof value !== "object" || value === null) return false
    const obj = value as Record<string, unknown>
    return (
        typeof obj.id === "string" &&
        (obj.documentType === undefined ||
            typeof obj.documentType === "string") &&
        (obj.name === undefined || typeof obj.name === "string") &&
        (obj.referenceNumber === undefined ||
            typeof obj.referenceNumber === "string")
    )
}

export function isWorkspaceDoc(value: unknown): value is {
    id: string
    referenceNumber?: string | null
    documentType?: string
} {
    if (typeof value !== "object" || value === null) return false
    const obj = value as Record<string, unknown>
    return (
        typeof obj.id === "string" &&
        (obj.referenceNumber === undefined ||
            obj.referenceNumber === null ||
            typeof obj.referenceNumber === "string") &&
        (obj.documentType === undefined || typeof obj.documentType === "string")
    )
}

export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null && !Array.isArray(value)
}

export function hasDocumentId(
    value: unknown
): value is { currentDocumentId: string } {
    if (typeof value !== "object" || value === null) return false
    const obj = value as Record<string, unknown>
    return typeof obj.currentDocumentId === "string"
}
